module.exports = __webpack_public_path__ + "img/zhhb-2.5408bfe3.png";